import "./required_label.css";

const RequiredLabel = ({ text }) => (
  <span>
    {text} <span className="required-label__asterisk">*</span>
  </span>
);

export default RequiredLabel;
